import { FC } from "react";
import { Helmet } from 'react-helmet';

export const Fonts : FC = () => {
    return (
        <div className="application">
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=M+PLUS+1p&display=swap" rel="stylesheet" />
            </Helmet>
        </div>
    );
};
